export default "https://cdn-static.gokick.com/assets/d8950a20925d8040d2b2bc8b449b43040bc9b501/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";